import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';

import {
  SkillLearningGeneralSettingsResponse,
  mergeSkillLearningGeneralSettings,
} from '../models/skill-learning.model';
import { SKILL_SETTINGS_API } from '../constants/skill-api.constants';

@Injectable()
export class SkillSettingsApiService {

  constructor(private http: Http) {}

  fetchGeneralSettings(): Observable<SkillLearningGeneralSettingsResponse> {
    return this.http
      .get(SKILL_SETTINGS_API.GENERAL)
      .map(response => response.json() as SkillLearningGeneralSettingsResponse)
      .map(settings => mergeSkillLearningGeneralSettings(settings));
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/common/skill-learning/services/skill-settings-api.service.ts